import { useRouter } from "next/router";
import { SearchParam } from "@/enums/search-param.enum";
import { isNonEmptyString } from "@/utils/type-guards/isNonEmptyStringGuard";

export const useLoginRedirectProps = (
  defaultRedirectionUrl?: string,
): { origin: string; redirectUrl: string } => {
  const { query } = useRouter();
  const redirectUrlInSearchParams = query[SearchParam.Redirect];

  const finalRedirectInURL = isNonEmptyString(redirectUrlInSearchParams)
    ? redirectUrlInSearchParams
    : defaultRedirectionUrl ?? "";
  const origin = String(query[SearchParam.Origin]);

  return { origin, redirectUrl: finalRedirectInURL };
};
